export type IComponentScrollApi = {
	getScrollTop: () => number
	getScrollLeft: () => number
	scroll: (x: number, y: number) => void
	scrollBy: (x: number, y: number) => void
	onScroll: (cb: (event: Event) => any) => () => void
}

export type InnerScroll = { x: number; y: number }

export type OnComponentsScrollListenerCb = (compId: string, scrollPosition: { left: number; top: number }) => void

export type InnerScrollApiType = {
	registerToInnerScroll(compId: string, scrollApi: IComponentScrollApi): () => void
	isScrollable(compId: string): boolean
	scrollTo(compId: string, x: number, y: number): void
	scrollBy(compId: string, x: number, y: number): void
	getComponentInnerScroll(compId: string): InnerScroll | undefined
	setOnComponentsScrollListener(callback: OnComponentsScrollListenerCb): void
}

export type IScrollableImperativeAPI = { scrollApi?: IComponentScrollApi }

export const InnerScrollApiSymbol = Symbol('InnerScrollApi')
